import React, { useRef } from "react";
import SvgGeoguidage from "../../_svg/Geoguidage";
import { withTranslation } from 'react-i18next';

const App = (props) => {
  const ref = useRef();
  const { t } = props
  const content = {
    title: t('applications.saphir.geoguiding'),
    description: t('applications.saphir.geoguiding.description')
  }
  return (
              <div className={"svg-container"} id={"svg-geocodage-saphir"} itemScope itemType="https://schema.org/WebPage">
                <div>
                  <SvgGeoguidage fill={"#b77830"} />
                  <h3 itemProp="alternativeHeadline">{content.title}</h3>
                  <span itemProp="description">
                    {content.description}
                  </span>
                </div>
              </div>
  );
};

const tr = withTranslation()(App);
export default tr;
